import { User, UserFull } from '@wellesley/openapi'
import { selectUploadFile } from '@wellesley/uploads'

export type ImgType = 'avatar' | 'header'

type HelperProps = {
  imgSize?: number
  type?: ImgType
  user?: Partial<User | UserFull>
}

const DEFAULT_AVATAR_SIZE = 40
const DEFAULT_HEADER_SIZE = 600

export const getUserImage = ({
  user,
  type = 'avatar',
  imgSize,
}: HelperProps) => {
  if (!user) return ''

  if (type === 'avatar') {
    return (
      selectUploadFile({
        size: imgSize ?? DEFAULT_AVATAR_SIZE,
        upload: user.avatar,
        allowWithoutSize: true,
      })?.uri || ''
    )
  }

  if (type === 'header' && 'header' in user) {
    return (
      selectUploadFile({
        size: imgSize ?? DEFAULT_HEADER_SIZE,
        upload: user.header,
        allowWithoutSize: true,
      })?.uri || ''
    )
  }

  return ''
}
